export function truncate(text, maxLength = 155) {
  if (!text) return "";
  if (text.length <= maxLength) return text;

  const sliced = text.slice(0, maxLength);
  const lastSpace = sliced.lastIndexOf(" ");
  const base = lastSpace > 0 ? sliced.slice(0, lastSpace) : sliced;
  return `${base}...`;
}
